import { ReactElement } from 'react';

import { ResultTypes } from '@cashier/cashier-model';
import { useUIConfiguration } from '@cashier/cashier-shared';

import { usePaymentResult } from '../hooks';
import { InformationBlock } from '../modules/informationBlock/v2';
import { StatusBlock } from '../modules/statusBlock/v2';

export interface PaymentResultProps {
  noVerticalPadding?: boolean;
}

export const PaymentResult = ({
  noVerticalPadding = false,
}: PaymentResultProps): ReactElement => {
  const paymentResult = usePaymentResult();

  const informationBlockType = useUIConfiguration('informationBlock', 'type');

  return ResultTypes.INFORMATION === paymentResult.type ? (
    <InformationBlock
      {...paymentResult.configuration}
      type={informationBlockType}
    />
  ) : (
    <StatusBlock
      noVerticalPadding={noVerticalPadding}
      onButtonClick={paymentResult.configuration.onButtonClick}
    />
  );
};
